import React from 'react';
import moment from 'moment-timezone';
import { VersionWrapper, Header, Info, Name, TitleSection, Title } from './styled';
import { IPolicy, IPolicyVersion } from '../../PrecisionPolicy/types';

interface IProps {
  policy: IPolicy;
  version: Pick<IPolicyVersion, 'is_active' | 'name' | 'created' | 'index'>;
  canEdit?: boolean;
  options?: React.ReactNode;
  children?: React.ReactNode;
}

const fmt = 'HH:mm:ss, MMM DD YYYY';

const PolicyVersion: React.FC<IProps> = ({
  policy,
  version,
  canEdit = false,
  children = null,
  options = null,
}) => {
  const { is_active: active, name, created, index } = version;
  return (
    <VersionWrapper active={active}>
      <TitleSection active={active}>
        <Header active={active}>
          <Name title={name}>{`${name}`}</Name>
          <Name>{`${active ? '  (Active)' : ''}`}</Name>
          {canEdit && options}
        </Header>
        <Info>
          <Title>
            Last updated:
            {moment(created).format(fmt)}| Rank: {index}
          </Title>
          {policy.notes && (
            <Title>
              Note:
              {policy.notes}
            </Title>
          )}
        </Info>
      </TitleSection>
      {children}
    </VersionWrapper>
  );
};

export default PolicyVersion;
